import React, { useEffect, useState } from "react";
import axios from "axios";
import { API } from "../config";
import '../../style/FichaseguimientoRector.css';

const FichaSeguimientoRevision = () => {
  const token = localStorage.getItem("token");

  const axiosConfig = {
    headers: {
      Authorization: `Bearer ${token}`
    }
  };

  const [casos, setCasos] = useState([]);
  const [seleccionado, setSeleccionado] = useState(null);
  const [loading, setLoading] = useState(false);

  const [form, setForm] = useState({
    observacion_institucional: "",
    responsable_seguimiento: "",
    fecha_atencion: "",
    urgente: false,
    requiere_citacion: false,
    estado_revision: "en_gestion"
  });

  /* ======================================
     🔥 CARGAR CASOS (DIRECTIVO)
  ====================================== */
  const cargarCasos = async () => {
    try {
      setLoading(true);

      const res = await axios.get(
        `${API}/ficha-seguimiento/casos/pendientes`,
        axiosConfig
      );

      console.log("📊 CASOS BACKEND:", res.data);

      setCasos(Array.isArray(res.data) ? res.data : []);
    } catch (error) {
      console.error("❌ Error cargando casos:", error?.response?.data || error);
      setCasos([]);
    } finally {
      setLoading(false);
    }
  };

  /* ======================================
     🔥 CARGAR REVISIÓN
  ====================================== */
  const cargarRevision = async (ficha_id) => {
    try {
      const res = await axios.get(
        `${API}/ficha-seguimiento/revision/${ficha_id}`,
        axiosConfig
      );

      const data = res.data;

      if (data) {
        setForm({
          observacion_institucional: data.observacion_institucional || "",
          responsable_seguimiento: data.responsable_seguimiento || "",
          fecha_atencion: data.fecha_atencion
            ? data.fecha_atencion.slice(0, 16)
            : "",
          urgente: data.urgente === 1,
          requiere_citacion: data.requiere_citacion === 1,
          estado_revision: data.estado_revision || "en_gestion"
        });
      } else {
        resetForm();
      }
    } catch (error) {
      console.error("❌ Error revisión:", error?.response?.data || error);
      resetForm();
    }
  };

  const resetForm = () => {
    setForm({
      observacion_institucional: "",
      responsable_seguimiento: "",
      fecha_atencion: "",
      urgente: false,
      requiere_citacion: false,
      estado_revision: "en_gestion"
    });
  };

  useEffect(() => {
    cargarCasos();
  }, []);

  /* ======================================
     🔥 SELECCIONAR CASO
  ====================================== */
  const seleccionarCaso = (caso) => {
    setSeleccionado(caso);
    cargarRevision(caso.id);
  };

  /* ======================================
     🔥 GUARDAR REVISIÓN
  ====================================== */
  const guardarRevision = async () => {
    if (!seleccionado) return alert("Seleccione un caso");

    try {
      await axios.patch(
        `${API}/ficha-seguimiento/revision/${seleccionado.id}`,
        form,
        axiosConfig
      );

      alert("✅ Revisión guardada correctamente");

      cargarCasos();
      setSeleccionado(null);
      resetForm();
    } catch (error) {
      console.error("❌ Error guardando:", error?.response?.data || error);
      alert("Error guardando revisión");
    }
  };

  const prioridadColor = (p) => {
    if (p === "critica") return "#c0392b";
    if (p === "alta") return "#e67e22";
    if (p === "media") return "#2980b9";
    return "#7f8c8d";
  };

  return (
    <div className="rev-container">

      {/* ================= LISTA ================= */}
      <div className="rev-left">
        <h2>📂 Casos Pendientes</h2>

        {loading && <p>Cargando...</p>}

        {!loading && casos.length === 0 && (
          <p>No hay fichas pendientes.</p>
        )}

        {casos.map((c) => (
          <div
            key={c.id}
            className={`rev-case-card ${
              seleccionado?.id === c.id ? "active" : ""
            }`}
            onClick={() => seleccionarCaso(c)}
            style={{
              borderLeft: `6px solid ${prioridadColor(c.prioridad)}`
            }}
          >
            <h4>{c.estudiante || "Sin nombre"}</h4>

            <p><strong>Asunto:</strong> {c.asunto}</p>
            <p><strong>Categoría:</strong> {c.categoria || "general"}</p>

            <p>
              <strong>Fecha:</strong>{" "}
              {c.fecha_registro
                ? new Date(c.fecha_registro).toLocaleDateString()
                : "N/A"}
            </p>

            <span className="rev-priority">{c.prioridad}</span>
          </div>
        ))}
      </div>

      {/* ================= DETALLE ================= */}
      <div className="rev-right">

        {!seleccionado ? (
          <div className="rev-empty">
            Seleccione un caso para ver detalle
          </div>
        ) : (
          <>
            <h2>🛠 Gestión Institucional</h2>

            <div className="rev-detail-box">
              <p><strong>Estudiante:</strong> {seleccionado.estudiante}</p>
              <p><strong>Asunto:</strong> {seleccionado.asunto}</p>
              <p><strong>Prioridad:</strong> {seleccionado.prioridad}</p>
            </div>

            <textarea
              className="rev-textarea"
              placeholder="Observación institucional..."
              value={form.observacion_institucional}
              onChange={(e) =>
                setForm({
                  ...form,
                  observacion_institucional: e.target.value
                })
              }
            />

            <input
              className="rev-input"
              placeholder="Responsable"
              value={form.responsable_seguimiento}
              onChange={(e) =>
                setForm({
                  ...form,
                  responsable_seguimiento: e.target.value
                })
              }
            />

            <label>Fecha atención</label>
            <input
              type="datetime-local"
              className="rev-input"
              value={form.fecha_atencion}
              onChange={(e) =>
                setForm({
                  ...form,
                  fecha_atencion: e.target.value
                })
              }
            />

            <div className="rev-checks">
              <label>
                <input
                  type="checkbox"
                  checked={form.urgente}
                  onChange={(e) =>
                    setForm({ ...form, urgente: e.target.checked })
                  }
                />
                Urgente
              </label>

              <label>
                <input
                  type="checkbox"
                  checked={form.requiere_citacion}
                  onChange={(e) =>
                    setForm({ ...form, requiere_citacion: e.target.checked })
                  }
                />
                Requiere citación
              </label>
            </div>

            <button className="rev-btn" onClick={guardarRevision}>
              💾 Guardar
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default FichaSeguimientoRevision;
